import ModuleModelCommon from 'common/models/module';

export default class ModuleModel extends ModuleModelCommon {}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    module: ModuleModel;
  }
}
